import React from 'react';
import SvgIcon from './SvgIcon';

const WindowAdd = props => (
    <SvgIcon viewBox="0 0 212 166" {...props}>
        <g id="Dashboard" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="2---Dashboard---No-Data" transform="translate(-328.000000, -1572.000000)" fillRule="nonzero">
                <g id="window-add" transform="translate(328.000000, 1572.000000)">
                    <path
                        d="M0,78.2608696 C0,80.4219457 1.75196739,82.173913 3.91304348,82.173913 L86.0869565,82.173913 C88.2480326,82.173913 90,80.4219457 90,78.2608696 L90,15.6521739 L0,15.6521739 L0,78.2608696 Z"
                        id="Path"
                        fill="#A4C3E4"
                    ></path>
                    <path
                        d="M86.0869565,0 L3.91304348,0 C1.75196739,0 0,1.75185 0,3.91304348 L0,15.6521739 L90,15.6521739 L90,3.91304348 C90,1.75185 88.2480326,0 86.0869565,0 Z"
                        id="Path"
                        fill="#8AA9CA"
                    ></path>
                    <path
                        d="M17.6086957,9.7826087 L9.7826087,9.7826087 C8.70211957,9.7826087 7.82608696,8.90751522 7.82608696,7.82608696 C7.82608696,6.7446587 8.70211957,5.86956522 9.7826087,5.86956522 L17.6086957,5.86956522 C18.6891848,5.86956522 19.5652174,6.7446587 19.5652174,7.82608696 C19.5652174,8.90751522 18.6891848,9.7826087 17.6086957,9.7826087 Z"
                        id="Path"
                        fill="#FFFFFF"
                    ></path>
                    <circle id="Oval" fill="#3777BC" cx="45" cy="48.9130435" r="19.5652174"></circle>
                    <path
                        d="M52.826087,46.9565217 L46.9565217,46.9565217 L46.9565217,41.0869565 C46.9565217,40.0064674 46.0804891,39.1304348 45,39.1304348 C43.9195109,39.1304348 43.0434783,40.0064674 43.0434783,41.0869565 L43.0434783,46.9565217 L37.173913,46.9565217 C36.0934239,46.9565217 35.2173913,47.8325543 35.2173913,48.9130435 C35.2173913,49.9935326 36.0934239,50.8695652 37.173913,50.8695652 L43.0434783,50.8695652 L43.0434783,56.7391304 C43.0434783,57.8196196 43.9195109,58.6956522 45,58.6956522 C46.0804891,58.6956522 46.9565217,57.8196196 46.9565217,56.7391304 L46.9565217,50.8695652 L52.826087,50.8695652 C53.9065761,50.8695652 54.7826087,49.9935326 54.7826087,48.9130435 C54.7826087,47.8325543 53.9065761,46.9565217 52.826087,46.9565217 Z"
                        id="Path"
                        fill="#FFFFFF"
                    ></path>
                </g>
            </g>
        </g>
    </SvgIcon>
);

WindowAdd.displayName = 'WindowAddIcon';

export default WindowAdd;
